<template>
    <div class="view view--tiles">
        <tile-list v-bind:show-add-button="false"
                   v-bind:show-bulk-actions="true"
                   v-bind:show-filters="{ 'category': true, 'created_at': true, 'updated_at': true, 'search': true }"
                   v-bind:show-paging="true"
                   v-bind:show-sort="true"
                   v-bind:show-thumbnail-slider="false"
                   v-bind:show-title="false"
        />
    </div>
</template>

<script>
    import tileList from '../../components/TileList.vue';

    export default {
        components: {
            tileList
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/tiles/Index.vue